import React from 'react';
import { useTranslation } from 'react-i18next';

import { faUserGraduate } from '@fortawesome/free-solid-svg-icons/faUserGraduate';
import { faNewspaper } from '@fortawesome/free-regular-svg-icons/faNewspaper';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';

import NavListItem from './NavListItem.jsx';

const Nav = () => {
  const { t } = useTranslation();
  const links = [
    { to: '/school-admin/dashboard', icon: faTachometerAlt, label: t('Dashboard') },
    {
      to: '/school-admin/articles',
      icon: faNewspaper,
      label: t('Articles'),
    },

    {
      to: '/school-admin/reports',
      icon: faChartPie,
      label: t('Reports'),
      // Only show the teacher report link in the nav. Other report pages remain routable
      // but are intentionally hidden from the navigation per user request.
      links: [
        { to: '/school-admin/reports/teacher', icon: faUserGraduate, label: t('TeacherReport') },
      ],
    },

    {
      href: '/logout',
      icon: faPowerOff,
      label: t('Logout'),
    },
  ];

  return (
    <nav className="col main-nav bg-white pr-0 py-5">
      <div className="nav flex-column pl-3">
        {links.map((l, i) => (
          <NavListItem key={i} {...l}>
            {l.links && (
              l.links.map((ll, ii) => (
                <NavListItem key={ii} {...ll} />
              ))
            )}
          </NavListItem>
        ))}
      </div>
    </nav>
  );
};

export default Nav;
